/**
 * @desc 曝光埋点配置
 * @example
 *  {
 *    sailing_c_x_realexposure_sw: 'item_id', key:埋点名 val:埋点唯一标识
 *    ...
 *  }
 */

export default {
  // sailing_c_x_realexposure_sw: 'item_id',
};
